import styles from "./Themes.module.scss"

const Themes: React.FC = () => (
    <div className={styles["themes-container"]}>

    </div>
)

export default Themes;